import { createSelector } from 'reselect';

const systemRootSelector = state => state;

const stateSelector = createSelector(
  systemRootSelector,
  system => ({
    preview: system.modes.preview,
    export: system.modes.export,
  }),
);

export const systemSelector = createSelector(
  stateSelector,
  state => ({
    ...state,
  }),
);

export default {
  systemSelector,
};
